import React, { useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Box,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import NoteAddIcon from "@mui/icons-material/NoteAdd";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentTurnedInIcon from "@mui/icons-material/AssignmentTurnedIn";
import AssignmentIcon from "@mui/icons-material/Assignment";
import HealingIcon from "@mui/icons-material/Healing";
import CancelIcon from "@mui/icons-material/Cancel";
import SoapNotesComponent from "./SoapNotesComponent";
import ServicesForms from "./ServicesForms";
import ServicesImages from "./ServicesImages";
import { useParams } from "react-router-dom";
import { getDecryptedUserType } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";

const EncounterData = ({ data,getUpdatedData,appointmentData }) => {
  const params = useParams();
const LoginUserType = getDecryptedUserType()
  // State for ServicesForms dialog
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedFormType, setSelectedFormType] = useState(null);
  const [selectedFormData, setSelectedFormData] = useState(null);

  // State for ServicesImages dialog
  const [openImageDialog, setOpenImageDialog] = useState(false);
  const [selectedImageType, setSelectedImageType] = useState(null);
const[selectedService,setselectedService]=useState()
  // Function to handle form chip click
  const handleFormClick = (formType, item) => {
    setSelectedFormType(formType);
    setSelectedFormData(item);
    setOpenFormDialog(true);
  };

  // Function to handle image chip click
  const handleImageClick = (imageType,item) => {
    setSelectedImageType(imageType);
    setselectedService(item);
    setOpenImageDialog(true);
  };
const fetchUpdatedData =()=>{
  getUpdatedData()
  setOpenImageDialog(false)
}
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 2, p: 2 }}>
      {data.length === 0 ? (
        <Typography variant="h6" color="textSecondary">
          No encounter data available.
        </Typography>
      ) : (
        data.map((item) => (
          <Card
            key={item.id}
            sx={{
              borderRadius: 3,
              boxShadow: 3,
              p: 2,
              borderLeft: "6px solid #05b6b3",
            }}
          >
            <CardContent>
              {/* Service Name */}
              <Typography variant="h6" fontWeight="bold" color="primary">
                {item.service} - {item.service_subtype}
              </Typography>

              <Box display="flex" flexWrap="wrap" gap={1.5} mt={2}>
                {item.has_pre_treatment === 1 && (
                  <Chip
                    icon={
                      item.filled_pretreatment_form_data ? (
                        <AssignmentTurnedInIcon color="success" />
                      ) : (
                        <AssignmentIcon color="error" />
                      )
                    }
                    label="Pre-Treatment"
                    sx={{
                      backgroundColor: item.filled_pretreatment_form_data
                        ? "#DFF2BF"
                        : "#FFBABA",
                      color: item.filled_pretreatment_form_data
                        ? "#4F8A10"
                        : "#D8000C",
                    }}
                    onClick={() => handleFormClick("Pre Treatment", item)}
                  />
                )}

                {/* Consent Form */}
                {item.has_consent_treatment === 1 && (
                  <Chip
                    icon={
                      item.filled_consent_form_data ? (
                        <CheckCircleIcon color="success" />
                      ) : (
                        <DescriptionIcon color="error" />
                      )
                    }
                    label="Consent Form"
                    sx={{
                      backgroundColor: item.filled_consent_form_data
                        ? "#DFF2BF"
                        : "#FFBABA",
                      color: item.filled_consent_form_data
                        ? "#4F8A10"
                        : "#D8000C",
                    }}
                    onClick={() => handleFormClick("Consent Treatment", item)}
                  />
                )}

                {/* Post-Treatment */}
                {item.has_post_treatment === 1 && (
                  <Chip
                    icon={
                      item.filled_posttreatment_form_data ? (
                        <HealingIcon color="success" />
                      ) : (
                        <CancelIcon color="error" />
                      )
                    }
                    label="Post-Treatment"
                    sx={{
                      backgroundColor: item.filled_posttreatment_form_data
                        ? "#DFF2BF"
                        : "#FFBABA",
                      color: item.filled_posttreatment_form_data
                        ? "#4F8A10"
                        : "#D8000C",
                    }}
                    onClick={() => handleFormClick("Post Treatment", item)}
                  />
                )}

                {/* Treatment Form */}
                {LoginUserType !== "Patient" &&
                <>
                {item.has_treatment_form === 1 && (
                  <Chip
                    icon={
                      item.filled_treatment_form_data ? (
                        <AssignmentTurnedInIcon color="success" />
                      ) : (
                        <NoteAddIcon color="error" />
                      )
                    }
                    label="Treatment Form"
                    sx={{
                      backgroundColor: item.filled_treatment_form_data
                        ? "#DFF2BF"
                        : "#FFBABA",
                      color: item.filled_treatment_form_data
                        ? "#4F8A10"
                        : "#D8000C",
                    }}
                    onClick={() => handleFormClick("Treatment Form", item)}
                  />
                )}
                </>}

                {/* Pre-Treatment Image */}
                <Chip
                  icon={
                    item.is_pre_treatment_images === 1 ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <CancelIcon color="error" />
                    )
                  }
                  label="Pre-Treatment Image"
                  sx={{
                    backgroundColor: item.is_pre_treatment_images
                      ? "#DFF2BF"
                      : "#FFBABA",
                    color: item.is_pre_treatment_images ? "#4F8A10" : "#D8000C",
                  }}
                  onClick={() => handleImageClick("Pre-Treatment Image",item)}
                />

                {/* Post-Treatment Image */}
                <Chip
                  icon={
                    item.is_post_treatment_images === 1 ? (
                      <CheckCircleIcon color="success" />
                    ) : (
                      <CancelIcon color="error" />
                    )
                  }
                  label="Post-Treatment Image"
                  sx={{
                    backgroundColor: item.is_post_treatment_images
                      ? "#DFF2BF"
                      : "#FFBABA",
                    color: item.is_post_treatment_images ? "#4F8A10" : "#D8000C",
                  }}
                  onClick={() => handleImageClick("Post-Treatment Image",item)}
                />
              </Box>

              {/* SOAP Notes Component */}
              {LoginUserType !== "Patient" &&
              <SoapNotesComponent
                serviceId={item.service_no} 
                appointmentData={appointmentData}
              />}
            </CardContent>
          </Card>
        ))
      )}

      {/* ServicesForms Dialog */}
      <Dialog open={openFormDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedFormType}
          <IconButton
            aria-label="close"
            onClick={() => setOpenFormDialog(false)}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {selectedFormType && (
            <ServicesForms formType={selectedFormType} formData={selectedFormData} appointmentData={appointmentData}/>
          )}
        </DialogContent>
      </Dialog>

      {/* ServicesImages Dialog */}
      <Dialog open={openImageDialog} maxWidth="md" fullWidth>
        <DialogTitle>
          {selectedImageType}
          <IconButton
            aria-label="close"
            onClick={() => setOpenImageDialog(false)}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <ServicesImages  imageType={selectedImageType} service={selectedService} getnewData={fetchUpdatedData} appointmentData={appointmentData}/>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default EncounterData;
